<template>
  <v-responsive id="videoWrapper">
    <!--        <p class="subheading font-weight-regular">-->
    <!--          https://collab-project.github.io/videojs-record/index.html<br>-->
    <!--          https://github.com/collab-project/videojs-record/wiki/Vue.js<br>-->
    <!--          https://github.com/collab-project/videojs-record#examples-->
    <!--        </p>-->


    <v-overlay
        absolute
        :opacity="isCountdownRunning ? 0.5 : 0"
    >
      <Countdown
          id="countdown"
          ref="countdown"
          @on-countdown-finished="onCountdownFinished"
      />
    </v-overlay>

    <video
        id="myVideo"
        class="video-js vjs-default-skin"
        playsinline
    />



  </v-responsive>
</template>

<script>
import 'video.js/dist/video-js.css'
//import 'videojs-record/dist/css/videojs.record.css'

import 'webrtc-adapter'
import RecordRTC from 'recordrtc'

import videojs from 'video.js'
// eslint-disable-next-line
import Record from 'videojs-record/dist/videojs.record.js'

import {isMobile} from 'mobile-device-detect';
import Countdown from "./Countdown";

export default {
  components: {Countdown},
  props: {},
  data: () => ({
    player: '',
    videoRecorded: false,
    isRecording: false,
    saveToFile: false,
    videoOptions: {
      controls: true,
      autoplay: false,
      fluid: true,
      loop: false,
      width: 960,
      height: 540,

      // width: { min: 1024, ideal: 1280, max: 1920 },
      // height: { min: 776, ideal: 720, max: 1080 },

      controlBar: {
        volumePanel: false,
        fullscreenToggle: false
      },
      plugins: {
        // configure videojs-record plugin
        record: {
          maxLength: 5,
          audio: true,
          //video: true,
          debug: true,

          audioChannels: 1,
          frameWidth: 1920,
          frameHeight: 1080,

          video: {
            //facingMode: "user",
            videoBitRate: 2500,
            audioSampleRate: 22050,
            // video constraints: set resolution of camera
            mandatory: {
              minWidth: 1920,
              minHeight: 1080,
            },
          },
        }
      }
    },
    isCountdownRunning: false
  }),
  mounted() {
    this.init();
  },
  async created() {

  },
  methods: {
    init() {
      this.getConfig().then(() => {

        /* eslint-disable no-console */
        this.player = videojs('#myVideo', this.videoOptions, () => {
          // print version information at startup
          var msg = 'Using video.js ' + videojs.VERSION +
              ' with videojs-record ' + videojs.getPluginVersion('record') +
              ' and recordrtc ' + RecordRTC.version;
          videojs.log(msg);
        });

        var self = this;

        // device is ready
        this.player.on('enumerateReady', () => {
          var devices = this.player.record().devices;
          console.log(devices);
        });

        // device is ready
        this.player.on('enumerateError', () => {
          console.log('enumerateError is ready!');

        });

        // device is ready
        this.player.on('timestamp', () => {
          // timestamps
          console.log('current timestamp: ', this.player.currentTimestamp);
          this.$emit('timestamp', this.player.currentTimestamp);
        });

        // device is ready
        this.player.on('progressRecord', () => {
          console.log('progressRecord is ready!', this.player.record().getDuration());
          this.$emit('timestamp', (30 - this.player.record().getDuration()).toFixed(2));

        });

        // device is ready
        this.player.on('deviceReady', () => {
          console.log('device is ready!');
        });

        // device is ready
        this.player.on('ready', () => {
          console.log('player is ready!');
          this.$nextTick(() => {
            self.player.record().getDevice();
          })
        });


        // user clicked the record button and started recording
        this.player.on('startRecord', () => {
          console.log('started recording!');
          this.isRecording = true;
          this.$emit('is-recording', true);
        });

        // user completed recording and stream is available
        this.player.on('finishRecord', () => {

          this.$emit('is-recording', false);

          this.$emit('on-finished-recording', this.player.recordedData);

          this.isRecording = false;
          // the blob object contains the recorded data that
          // can be downloaded by the user, stored on server etc.
          //console.log('finished recording: ', this.player.recordedData);


          if (this.saveToFile) {
            this.player.record().saveAs({'video': 'my-video'});
          }

          //https://github.com/collab-project/videojs-record/blob/master/examples/upload/fine-uploader.html
          //https://github.com/collab-project/videojs-record/blob/master/examples/upload/jquery.fileupload.html

          this.videoRecorded = true

          // this.resetform();
          //  this.showForm = true;
        });

        // error handling
        this.player.on('error', (element, error) => {
          console.warn(error);
          this.$emit('on-error', error);

        });

        this.player.on('deviceError', () => {
          console.error('device error:', this.player.deviceErrorCode);
          this.$emit('on-device-error', this.player.deviceErrorCode);
        });

      })
    },
    async getConfig() {
      console.log('config read ...', isMobile)

      var configFile = isMobile ? 'config_mobile.json' : 'config.json';

      let config = await fetch('./' + configFile).then(r => r.json());
      this.videoOptions = Object.assign({}, this.videoOptions, config.video);
      this.saveToFile = config.saveToFile;

      console.log(configFile, config);

      console.log('config read finished')
    },
    initRecorder() {
      this.player.record().getDevice();
    },
    startDevice() {
      this.player.record().getDevice();
    },
    stopDevice() {
      this.player.record().stopDevice();
    },

    resetPlayer() {
      this.$emit('on-error', null);
      this.player.reset();
    },
    startRecording() {
      if (!this.isRecording) {
          this.player.record().start();
      }
    },
    stopRecording() {
      this.player.record().stop();
    },
    playVideo() {
      this.player.play();
    },
    enumerateDevices() {
      this.player.record().enumerateDevices();
    },
    startCountdown() {
      this.isCountdownRunning = true;
      this.$refs.countdown.startCountdown();
    },
    onCountdownFinished() {
      console.log('on Countdown FINISHED');
      this.isCountdownRunning = false;
      this.startRecording();
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },


};
</script>

<style>
/*#videoWrapper {*/
/*  position: relative !important;*/
/*  !*overflow: hidden !important;*!*/
/*  width: 100% !important;*/
/*  height: 100% !important;*/
/*}*/
/*#myVideo {*/
/*  width: 100% !important;*/
/*  !*position: absolute !important;*!*/
/*  top: 50% !important;*/
/*  left: 50% !important;*/
/*  transform: translate(-50%, -50%) !important;*/
/*}*/
/*#countdown {*/
/*  width: 100% !important;*/
/*  position: absolute !important;*/
/*  top: 50% !important;*/
/*  left: 50% !important;*/
/*  transform: translate(-50%, -50%) !important;*/
/*}*/
</style>